import React, { useEffect } from 'react'
import { Switch, Route } from 'react-router-dom'
import { SettingsMenu } from './SettingsMenu/SettingsMenu'
import { SettingsAreaGeneral } from './SettingsArea/SettingsAreaGeneral/SettingsAreaGeneral'
import { SettingsAreaBilling } from './SettingsArea/SettingsAreaBilling/SettingsAreaBilling'
import { SettingsAreaProfile } from './SettingsArea/SettingsAreaProfile/SettingsAreaProfile'
import commonsService from '@/services/commons.service'
import sessionService from '@/app-domains/user/session/session.service'

import './SettingsPage.scoped.sass'
export function SettingsPage () {
  // const [showMenu, setShowMenu] = useState(true)

  useEffect(() => {
    if (!sessionService.isUserLogged()) {
      commonsService.goToPage('/auth')
    }
  }, [])
  return (
    <div className='settings-page-container'>
      <div className="settings-page">
        <div className="settings-page-title">Settings</div>
        <div className="container">
          <div className="menu">
            <SettingsMenu />
          </div>
          <div className="content">
            <Switch>
              <Route exact path={'/settings'}>
                <SettingsAreaProfile/>
              </Route>
              <Route exact path={'/settings/account'}>
                <SettingsAreaGeneral/>
              </Route>
              <Route exact path={'/settings/billing'}>
                <SettingsAreaBilling />
              </Route>
            </Switch>
          </div>
        </div>
      </div>
    </div>
  )
}
